module.exports = __webpack_public_path__ + "static/media/speakers_logos_HUAWEI.ae6c85cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_HUAWEI.jpg
// module id = 271
// module chunks = 0